import axios from 'axios'
import { UUID } from '@/types'
import { WorkerActivityStats } from '@/types/process'
import { unique } from '.'

// List workers activity statistics for a process
export const listProcessWorkersActivity = unique(async (processId: UUID): Promise<WorkerActivityStats[]> => (await axios.get(`process/${processId}/activity-stats/`)).data)
